var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 5.50013C8 5.22399 7.77614 5.00013 7.5 5.00013H3.5C3.22386 5.00013 3 5.22399 3 5.50013C3 5.77627 3.22386 6.00013 3.5 6.00013H7.5C7.77614 6.00013 8 5.77627 8 5.50013Z",
    fill: "#272727"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33333 7.50013C7.33333 7.22399 7.10948 7.00013 6.83333 7.00013H3.5C3.22386 7.00013 3 7.22399 3 7.50013C3 7.77627 3.22386 8.00013 3.5 8.00013H6.83333C7.10948 8.00013 7.33333 7.77627 7.33333 7.50013Z",
    fill: "#272727"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 9.00013C7.77614 9.00013 8 9.22399 8 9.50013C8 9.77627 7.77614 10.0001 7.5 10.0001H3.5C3.22386 10.0001 3 9.77627 3 9.50013C3 9.22399 3.22386 9.00013 3.5 9.00013H7.5Z",
    fill: "#272727"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 13.5001H11.6667C12.6792 13.5001 13.5 12.6793 13.5 11.6668V8.00014C13.5 7.724 13.2761 7.50014 13 7.50014H10.8333V2.2956C10.8333 1.34666 9.76074 0.794684 8.98856 1.34624L8.87186 1.4296C8.35153 1.80126 7.64672 1.80001 7.12395 1.4266C6.25471 0.805715 5.07862 0.805715 4.20938 1.4266C3.68661 1.80001 2.9818 1.80126 2.46148 1.4296L2.34478 1.34624C1.5726 0.794684 0.5 1.34666 0.5 2.2956V11.0001C0.5 12.3808 1.61929 13.5001 3 13.5001ZM4.79062 2.24034C5.31217 1.8678 6.02117 1.8678 6.54271 2.24034C7.41074 2.86035 8.58263 2.86509 9.4531 2.24333L9.56979 2.15997C9.68011 2.08118 9.83333 2.16003 9.83333 2.2956V11.6668C9.83333 11.9669 9.90543 12.2501 10.0332 12.5001H3C2.17157 12.5001 1.5 11.8286 1.5 11.0001V2.2956C1.5 2.16003 1.65323 2.08118 1.76354 2.15997L1.88024 2.24333C2.7507 2.86509 3.9226 2.86035 4.79062 2.24034ZM10.8333 11.6668V8.50014H12.5V11.6668C12.5 12.127 12.1269 12.5001 11.6667 12.5001C11.2064 12.5001 10.8333 12.127 10.8333 11.6668Z",
    fill: "#272727"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.b974c7eded8e9f2ea6396c9244351cb3.svg";
export { ForwardRef as ReactComponent };